import ChartLegendItem from './ChartLegendItem';
import './chart-legend-item.scss';

export { ChartLegendDot } from './ChartLegendItem';
export default ChartLegendItem;
